<template>
  <div :class="['station-queue-thumb-panel', { 'station-queue-thumb-small': isQueueDisplayTypeSmall, 'station-queue-thumb-large': isQueueDisplayTypeLarge} ]" @click.prevent="panelClicked">
    <div class="panel-container">
      <div class="thumbnail-container" v-if="accountHasOrderEditor">
        <div v-if="hasPreviewDisplayData" v-html="panel.orderItem.svgDisplayData" class="thumbnail" @click.prevent="previewClicked" />
        <h2 v-if="!hasPreviewDisplayData" class="text-center text-muted font-italic">
          No preview available
        </h2>
      </div>
      <div class="info-bar">
        <div class="row no-gutters">
          <div class="col-9">
            <div class="row no-gutters">
              <div class="col-5 stock">{{panel.orderItem.stock.name}}</div>
              <div class="col-3 stock">{{panel.orderItem.glassHeight}} x {{panel.orderItem.glassWidth}}</div>
              <div class="col-4 panel-location-info">{{panelStationName}}</div>
            </div>
            <div class="row no-gutters">
              <div class="col-5"><i class="fal fa-scanner fa-fw mr-2"></i> {{panel.barcode}}</div>
              <div class="col-3">{{panel.order.sequenceNumber}}</div>
              <div class="col-4"><i class="fal fa-clock fa-fw mr-2"></i> {{panelStationDuration}}</div>
            </div>
          </div>
          <div class="col-3 station-queue-thumb-panel-options text-right">
            <button class="btn btn-default" @click.prevent="panelClicked">
              <i class="fal fa-info-circle"></i> Info
            </button>
            <button class="btn btn-danger ml-2" @click.prevent="removePanelClicked" v-if="canRemovePanel">
              <i class="fal fa-times"></i> Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.station-queue-thumb-panel {
  width: 50%;
  margin: 0;
  font-size: 14px;
  color: #A0A0A0;
  cursor: pointer;
}
.station-queue-thumb-small {
  width: 50%;
}
.station-queue-thumb-large {
  width: 100%;
}
.station-queue-thumb-panel .panel-container {
  margin: 0.25rem;
  padding: 6px;
  background-color: #333333;
}
.station-queue-thumb-panel .thumbnail-container {
  border: 1px solid #1e1e1e;
  background-color: #272727;
  margin: 0.25rem;
  height: 200px;
}
.station-queue-thumb-large .thumbnail-container {
  height: 400px;
}
.station-queue-thumb-panel .thumbnail {
  max-width: 100%;
  max-height: 100%;
}
.station-queue-thumb-panel .thumbnail:hover {
  outline: 2px solid #4da9ff;
}
.station-queue-thumb-panel .thumbnail svg {
  width: 100%;
  height: 200px !important;
  max-width: 100%;
  max-height: 100%;
}
.station-queue-thumb-large .thumbnail svg {
  height: 400px !important;
}

.station-queue-thumb-panel .thumbnail svg path.svg-dimension-line,
.station-queue-thumb-panel .thumbnail svg path.svg-dimension-arrow,
.station-queue-thumb-panel .thumbnail svg path.svg-edgework-legend-box {
  fill: #FFFFFF !important;
  stroke: #FFFFFF !important;
}
.station-queue-thumb-panel .thumbnail svg text {
  fill: #FFFFFF !important;
}
.station-queue-thumb-panel .thumbnail svg text.svg-dimension-text {
  stroke: #272727 !important;
}

.station-queue-thumb-panel > div {
  line-height: 1.2rem;
  vertical-align: middle;
}
.station-queue-thumb-panel .panel-location-info {
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-thumb-panel .stock {
  color: #4da9ff;
  font-weight: 600;
}
.station-queue-thumb-panel .station {
  font-weight: bold;
  color: #4fcc3b !important;
}
.station-queue-thumb-panel .row {
  padding: 3px;
}
.station-queue-thumb-panel-options {
  position: relative;
  font-size: 0.9rem;
}

.station-queue-thumb-panel-options .btn {
  width: 52px;
  height: 46px;
  padding: 0;
  font-size: 11px;
  text-transform: uppercase;
}
.station-queue-thumb-panel-options .btn > i {
  font-size: 1.2rem;
  display: block;
  padding: 4px 0px 5px 0px;
}

</style>

<script>
import moment from 'moment'

import { ProductionStationQueueDisplayTypes } from '@/store/types'

export default {
  name: 'QueuePanelThumbItem',
  props: {
    panel: Object,
    currentStationId: Number,
    removeEnabled: {
      type: Boolean,
      default: true
    },
    highlightColour: String,
    queueDisplayType: String
  },
  data() {
    return {
      panelTimeInQueue: 0
    }
  },
  mounted() {
    this.updatePanelTimer()
    this.$options.queuePanelTimer = setInterval(this.updatePanelTimer, 15000)
  },
  beforeDestroy () {
    clearInterval(this.$options.queuePanelTimer)
  },
  computed: {
    panelStationDuration() {
      if(!this.panel || !this.panel.currentStationStartDate)
        return ''

      if(this.panelTimeInQueue <= 60)
        return `${this.panelTimeInQueue} mins`      
      if(this.panelTimeInQueue >= 24*60)
        return '24+ hrs'

      let hours = Math.floor(this.panelTimeInQueue / 60)
      return `${hours} hrs`
    },
    panelStationName() {
      if(!this.panel || !this.panel.currentProductionStation)
        return ''

      return `At ${this.panel.currentProductionStation.name}`
    },
    canRemovePanel() {
      if(!this.panel)
        return false
        
      // Can only remove if the panel is at the station currently displaying it
      return this.removeEnabled && this.panel.currentProductionStationId == this.currentStationId
    },
    canDisplayPreview() {
      if(!this.panel)
        return false
        
      return true
    },
    hasPreviewDisplayData() {
      if(this.panel && this.panel.orderItem && this.panel.orderItem.svgDisplayData)
        return true
      return false
    },
    accountHasOrderEditor() {
      // If the account has no order editor feature available, don't display thumbnails at all
      return this.accountHasProductFeature(this.AccountProductFeatureTypes.orderEditor)
    },
    panelIsOnHold() {
      if(this.panel && this.panel.order && this.panel.order.isOnHold)
        return true
      return false
    },
    isQueueDisplayTypeSmall() {
      return this.queueDisplayType == ProductionStationQueueDisplayTypes.smallThumbnail
    },
    isQueueDisplayTypeLarge() {
      return this.queueDisplayType == ProductionStationQueueDisplayTypes.largeThumbnail
    }
  },
  methods: {
    updatePanelTimer() {
      if(this.panel.currentStationStartDate == null)
        this.panelTimeInQueue = 0
      else
        this.panelTimeInQueue = Math.floor(moment.duration(moment().diff(this.panel.currentStationStartDate)).asMinutes())
    },
    panelClicked(ev) {
      this.$emit('panelClicked', ev)
    },
    previewClicked(ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.$emit('previewClicked', ev)
    },
    removePanelClicked(ev) {
      ev.stopPropagation()
      ev.preventDefault()
      this.$emit('removePanel')
    }
  }
}
</script>